import { Badge, Tooltip } from '@mantine/core';
import { formatSignedPct, severityColor, yieldVarianceSeverity } from '../format';

/** Visual variance highlight for actual-vs-recipe dry yield (BUILD_SPEC.md §8.3:
 * "yield shown vs recipe"; §11: "variance badge"). Mirrors the identical pattern
 * features/silo-counts/components/VarianceBadge.tsx uses for ledger-vs-measured
 * silo variance. Tooltip legend added guidance wave 2026-08-25 — the bare badge
 * gave a first-time user a colored percentage with no idea what "yield" means or
 * why green/amber/red, matching format.ts's WARN_PP/HIGH_PP bands (3pp / 8pp). */
export function YieldVarianceBadge({ variancePct }: { variancePct: number | string | null }) {
  const severity = yieldVarianceSeverity(variancePct);
  return (
    <Tooltip
      multiline
      w={280}
      label="Yield = dry mass out ÷ dry mass in, vs the recipe's expected yield. Green: within 3 points of expected. Amber: 3–8 points off. Red: more than 8 points off."
    >
      <Badge color={severityColor(severity)} variant="light" size="lg">
        {formatSignedPct(variancePct)}
      </Badge>
    </Tooltip>
  );
}
